import { connect } from 'react-redux';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  dot: {
    animation: `1s $blink infinite`,
    '&:nth-child(1)': {
      animationDelay: '0ms',
    },
    '&:nth-child(2)': {
      animationDelay: '250ms',
    },
    '&:nth-child(3)': {
      animationDelay: '500ms',
    },
  },
  '@keyframes blink': {
    '50%': {
      color: 'transparent',
    },
  },
});

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
const AsrQueueingMessageLoader = ({ value }: { value: boolean }) => {
  const classes = useStyles();
  return (
    <span>
      {value && (
        <span>
          <span className={classes.dot}>.</span>
          <span className={classes.dot}>.</span>
          <span className={classes.dot}>.</span>
        </span>
      )}
    </span>
  );
};

const mapStateToProps = ({ scribeConversation: { transcripts } }, { transcriptId }) => ({
  value: transcripts[transcriptId]?.mutationsQueuedByHumanMutation?.length > 0,
});

export default connect(mapStateToProps, {})(AsrQueueingMessageLoader);
